import { useEffect } from "react";

import { useJitsu } from "@jitsu/react";
import * as Sentry from "@sentry/react";
import { useCurrentUser } from "data/user/useCurrentUser";

const jitsuIdentified = false;

export function useJitsuIdentify(assessmentId: string, tenant: string) {
  const { id, set } = useJitsu();
  const { user } = useCurrentUser();

  useEffect(() => {
    if (!jitsuIdentified && user?.me) {
      set({
        cadmus: {
          tenant: user.institution?.tenant,
          assessment_id: assessmentId,
          session_id: user.sessionId,
        },
      });
      // ID the user but do not send the event to the server
      id({ id: user.me.id, role: "lecturer" }, true);

      Sentry.setContext("cadmus", { tenant, assessment_id: assessmentId });
      Sentry.setUser({ id: user.me.id });
    }
  }, [user, assessmentId, tenant, id, set]);
}
